module.exports = __webpack_public_path__ + "img/marvel-knights.2c767ffb.svg";